<template>
  <section>
    <b-field>
      <template v-if="theme" #label>
        {{theme}}
      </template>
      <br />
      <b-field>
        <b-select v-model="value" placeholder="Select Destination" @input="setLocation()">
          <option
              v-for="option in options"
              :value="option"
              :key="option.code">
            {{ option.code }} - {{option.city}}, {{option.state? option.state: option.country}}
          </option>
        </b-select>
      </b-field>
    </b-field>
  </section>
</template>

<script>
  import debounce from "lodash.debounce";

  export default {
  props: {
    theme:{},
    preferred: {},
    options: {},
  },
  data() {
    return {
      value: null,
      searchedName: '',
    }
  },
  methods: {
    setLocation() {
      this.$emit('locUpdate', this.value);
    }
  },
  computed: {
  },
  mounted() {
    this.value = this.preferred;
    if (this.value) {
      this.setLocation()
    }
  }
}
</script>
